import * as React from "react";
import Skeleton from "react-loading-skeleton";
import { generateImgSrc } from "src/share/utils/generateImgSrc";

function randomHeight() {
  return Math.round(Math.random() * (500 - 300 + 1) + 300);
}

export const NewsCardLoader = () => {
  return (
    <div className="white-background news-card">
      <img src={generateImgSrc(500, randomHeight())} className="news-card__image" data-text="User Avatar" />
      <div className="news-card__info">
        <h5 className="news-card__title">
          <Skeleton count={2} height={10} />
        </h5>
        <span className="news-card__details">
          <Skeleton count={1} height={7} width={'20%'} /> <Skeleton count={1} height={6} width={'30%'} />
        </span>
        <p className="news-card__description">
          <Skeleton count={Math.round(Math.random() * (5 - 3) + 3)} height={7} />
        </p>
        <Skeleton height={30} width={'6rem'}/>
      </div>
    </div>
  );
};
